export const ITEMS_PER_PAGE = 10;
export const BASE_URL_TAAL = process.env.REACT_APP_REST_ENDPOINT;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const ENABLE_SECURITY = process.env.REACT_APP_ENABLE_SECURITY;
export const ERROR_BOUNDARY = process.env.REACT_APP_ERROR_BOUNDARY;
export const REDIRECT_ON_UNAUTHORIZED = process.env.REACT_APP_REDIRECT_ON_UNAUTHORIZED;
